export function Background({ style }) {
  return <div className="blurred-background" style={style}></div>;
}
